// src/AuthContext.js

import React, { createContext, useContext, useState, useCallback, memo } from 'react';

const AuthContext = createContext(null);

export const AuthProvider = memo(({ children }) => {
  const [user, setUser] = useState(() => {
    try {
      const stored = localStorage.getItem('qronetic_user');
      return stored ? JSON.parse(stored) : null;
    } catch {
      return null;
    }
  });

  const login = useCallback((userData) => {
    setUser(userData);
    try {
      localStorage.setItem('qronetic_user', JSON.stringify(userData));
    } catch {}
  }, []);

  const logout = useCallback(() => {
    setUser(null);
    try {
      localStorage.removeItem('qronetic_user');
    } catch {}
  }, []);

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
});

AuthProvider.displayName = 'AuthProvider';

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
};